<template>
  <div id="bucketfile-dialog">
    <el-dialog
      title="创建目录"
      :visible.sync="dialog"
      width="40%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :rules="rules" ref="form" :model="ruleForm" label-width="100px">
        <el-form-item label="目录名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="resetForm('form')"
          >取 消</el-button
        >
        <el-button :loading="loading" type="primary" @click="submitForm('form')"
          >立即创建</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="上传文件"
      :visible.sync="dialog2"
      width="40%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-upload
        drag
        :multiple="true"
        :auto-upload="false"
        with-credentials
        ref="upload"
        class="upload"
        :action="upload"
        name="file"
        :limit="5"
        :on-success="success"
        :on-error="error"
        :data="filedata"
        :on-exceed="exceed"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将插件拖到此处，或
          <em>点击选取</em>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="fileReset">取 消</el-button>
        <el-button :loading="loading" type="primary" @click="submitFile"
          >立即上传</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "bucketfile-dialog",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    dialog2: {
      type: Boolean,
      default: false
    },
    bucketName: {
      type: String
    },
    parent: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      ruleForm: {
        // 创建file
        name: ""
      },
      rules: {
        // 创建file
        name: [
          {
            required: true,
            message: "请输入文件名",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    upload() {
      return (this.$http.defaults.baseURL || "") + "/gavial/v1/mos/object"; // 上传地址
    },
    filedata() {
      return {
        bucket: this.bucketName,
        parent: this.parent
      };
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.newFile();
        }
      });
    },
    newFile() {
      this.loading = true;
      this.$http
        .post(
          `/gavial/v1/mos/object/dir?bucket=${this.bucketName}&name=${this.ruleForm.name}&parent=${this.parent}`
        )
        .then(() => {
          this.$notify({
            type: "success",
            title: "成功",
            message: `${this.ruleForm.name} 创建成功`,
            duration: 2000
          });
          this.resetForm("form");
          this.$emit("refush");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit("update:dialog", false);
    },
    fileReset() {
      this.$emit("update:dialog2", false);
    },
    submitFile() {
      if (this.$refs.upload.uploadFiles.length === 0) {
        this.$message({
          type: "warning",
          message: "请选择一个文件"
        });
      } else {
        this.loading = true;
        this.$refs.upload.submit();
      }
    },
    success() {
      this.$notify({
        type: "success",
        title: "成功",
        message: `文件上传成功`,
        duration: 2000
      });
      this.fileReset();
      this.loading = false;
      this.$refs.upload.clearFiles();
      this.$emit("refush");
    },
    error() {
      this.$notify({
        type: "error",
        title: "错误",
        message: `文件上传失败`,
        duration: 2000
      });
      this.loading = false;
    },
    exceed() {
      this.$message({
        type: "error",
        message: "选中文件个数超出限制(5个)！"
      });
    }
  }
};
</script>

<style lang="scss">
.el-upload {
  width: 100%;
  .el-upload-dragger {
    width: 100%;
  }
}
</style>
